import React from 'react';
const YoutubePreview = (props) => {
    return (React.createElement("iframe", { 
        // TODO: Upgrade @types/react to use the `loading` prop here.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        loading: "lazy", width: props.width, height: props.height, src: `https://www.youtube.com/embed/${props.videoId}`, frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }));
};
export default React.memo(YoutubePreview);
//# sourceMappingURL=YoutubePreview.js.map